<template>
  <div class="content-container">
    <filter-location-statuses-data />
    <div class="content-wrap">
      <TopMenu />
      <location-latest-status :location-id="locationId" />
    </div>
  </div>
</template>

<script>
import TopMenu from "../components/TopMenu.vue";
import FilterLocationStatusesData from "@/components/FilterLocationStatusesData.vue";
import LocationLatestStatus from "@/components/LocationLatestStatus.vue";

export default {
  name: "LocationLatestStatusView",
  components: {
    TopMenu,
    FilterLocationStatusesData,
    LocationLatestStatus,
  },
  computed: {
    locationId() {
      return Number(this.$route.params.id);
    },
  },
};
</script>

<style scoped>
.content-container {
  background-color: #f5f4f2;
}
</style>
